module.exports = __webpack_public_path__ + "static/media/isong.c895d493.svg";